import React, { ReactNode } from "react";
import { classNames } from "../utils";

type Props = {
  title?: string | JSX.Element;
  children?: ReactNode;
  className?: string;
};

const FormDividedColumnContainer = ({ title, children, className }: Props) => {
  return (
    <div className={classNames("mb-3", className ?? "")}>
      <div className="font-semibold text-xl leading-7 text-gray-900 mb-4">
        {title ?? ""}
      </div>
      <div className="flex-1 p-6 border rounded-xl bg-slate-100">
        {children}
      </div>
    </div>
  );
};

export default FormDividedColumnContainer;
